(async () => {
  const {
    updateURLParams,
    historyPush,
    parseHTML
  } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('product-form', class extends baseComponent.default {
    elements = {
      form: 'form',
      addButton: '[data-add-button]',
      buyButton: '[data-buy-button]',
      soldOutButton: '[data-sold-out-button]',
      notifyForm: '[data-notify-form]',
      notifyEmail: '[data-notify-email]',
      notifyButton: '[data-notify-button]',
      notifySuccess: '[data-notify-success]',
      notifyError: '[data-notify-error]',
      input: '[data-variant-id-input]',
      sellingPlanInput: 'input[name="selling_plan"]'
    };
    async render() {
      this._enableInput();
      this.cartSection = document.querySelector('main-cart');
      this.isProductPage = this.getAttribute('page-type') === 'product';
      this.listenTo('variantChange', (e, data) => {
        this._rerender(data);
        if (data.variant) {
          this._rerenderVariantInput(data)
        }
      });
      this.on('cartChange', (e, data) => {
        this._updateQtyStatus(data.variantId)
      }, false)
      // Always use AJAX for add-to-cart to handle validation errors inline
      this.$form.addEventListener('submit', this._handleSubmit.bind(this));
      if (this.$notifyButton) {
        this.$notifyButton.addEventListener('click', this._handleNotifySubmit.bind(this));
      }
      // Track if we should redirect to cart page on success
      this.redirectToCart = !this.hasAttribute('cart-popup');
      
      if (this.$sellingPlanInput && this.hasAttribute('selling-plan-enable')) {
        this.currentSellingPlanId = this.querySelector('input[name="selling_plan"]').value;
        const {observeInputValueChange} = await import(window.theme.modules.sellingPlanUtil);
        observeInputValueChange(this.$sellingPlanInput, this._handleSellingPlanChange.bind(this));
      }
    };
    
    _handleSellingPlanChange(newSellingPlanId) {
      if (newSellingPlanId === this.currentSellingPlanId) 
        return;      
      this.currentSellingPlanId = newSellingPlanId;
      const { queryURL, currentURL } = updateURLParams({ 'selling_plan': this.currentSellingPlanId, 'variant': this.getAttribute('current-variant') }, this.sectionId);
      if (this.isProductPage)
        historyPush(currentURL);
      this._fetchPageWithVariant(queryURL, html => {
        this.forwardEvent('sellingPlanChange', {
          html: html
        })
      }); 
    };

    _enableInput() {
      this.$input.disabled = false;
    }
    
    _fetchPageWithVariant(url, onResponse) {
      return fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = parseHTML(responseText)
        onResponse(html);
      });
    };

    _rerender(data) {
      const isHiddenAddBtn = data.html.querySelector('[data-add-button]').hasAttribute('hidden');
      const isHiddenSoldOutBtn = data.html.querySelector('[data-sold-out-button]').hasAttribute('hidden');
      this.$addButton.toggleAttribute('hidden', isHiddenAddBtn);
      this.$buyButton?.toggleAttribute('hidden', isHiddenAddBtn);
      this.$soldOutButton.toggleAttribute('hidden', isHiddenSoldOutBtn);

      // Update sold-out button text (for "Maximum in Cart" vs "Sold Out" distinction)
      const newSoldOutText = data.html.querySelector('[data-sold-out-button] .\\#button-text');
      if (newSoldOutText && this.$soldOutButton) {
        const currentSoldOutText = this.$soldOutButton.querySelector('.\\#button-text');
        if (currentSoldOutText) {
          currentSoldOutText.textContent = newSoldOutText.textContent;
        }
      }

      // Handle notify form visibility
      const newNotifyForm = data.html.querySelector('[data-notify-form]');
      if (this.$notifyForm && newNotifyForm) {
        this.$notifyForm.toggleAttribute('hidden', newNotifyForm.hasAttribute('hidden'));
        this.$notifyForm.dataset.variantId = newNotifyForm.dataset.variantId;
        this._resetNotifyForm();
      }
    };
    
    _rerenderVariantInput(data) {
      this.setAttribute('current-variant', `${data.variant.id}`);
      const value = data.html.querySelector(this.elements.input).value;
      this.$input.value = value;
    };
    
    _handleSubmit(e) {
      e.preventDefault();
      this.formData = new FormData(e.target);
      this._addToCartRequest();
    };

    _addToCartRequest() {
      this._setLoading(true);
      this._clearError(); // Clear any previous error

      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          "Accept": "application/javascript"
        },
        body: this.formData
      })
      .then(res => {
        // Must check response.ok - Fetch doesn't reject on 4xx
        if (!res.ok) {
          return res.json().then(err => Promise.reject(err));
        }
        return res.json();
      })
      .then((data) => {
        // Success - item added to cart
        if (this.redirectToCart) {
          // cart_type = "page" - redirect to cart
          window.location.href = window.routes.cart || '/cart';
        } else {
          // cart_type = "drawer" or "popup" - show cart popup
          this.trigger('updateCart', {
            callback: () => {
              this._setLoading(false);
              this._updateQtyStatus(this.formData.get('id'));
              if (this.cartSection) {
                this.cartSection.update();
              } else {
                this.trigger('openPopup', { target: 'CART' });
              }
            }
          });
        }
      })
      .catch(error => {
        this._setLoading(false);
        // Extract error message from various response formats
        const message = error.description || error.message ||
          (error.errors && error.errors[0]) ||
          'Unable to add item to cart. Please try again.';
        this._showError(message);
      });
    };

    _updateQtyStatus(variantId) {
      const url = `${this.getAttribute('product-url')}?variant=${variantId}&section_id=${this.getAttribute('section-id')}`;
      this._fetchPageWithVariant(url, html => {
        this.trigger('qtyStatusUpdate', {html: html, variantId: variantId})
        this._rerender({html: html})
      })
    };
    
    _setLoading(status) {
      status
        ? this.$addButton.setAttribute('loading', '')
        : this.$addButton.removeAttribute('loading');
      // status ? this.$addButton.setAttribute('disabled', true) :
      //   this.$addButton.removeAttribute('disabled');
      // this.$addButton.textContent = status ? window.theme.i18n.loading : window.theme.i18n.addToCart;
    };

    _showError(message) {
      // Find or create error container
      let errorEl = this.querySelector('[data-cart-error]');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.setAttribute('data-cart-error', '');
        errorEl.className = '#product-form-error';
        errorEl.setAttribute('role', 'alert');
        errorEl.setAttribute('aria-live', 'polite');
        // Insert before the #grid containing buttons
        const gridEl = this.$form.querySelector('.\\#grid');
        if (gridEl) {
          gridEl.parentElement.insertBefore(errorEl, gridEl);
        } else {
          this.$form.insertBefore(errorEl, this.$form.firstChild);
        }
      }

      errorEl.innerHTML = `
        <svg aria-hidden="true" focusable="false" class="#icon" viewBox="0 0 13 13">
          <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>
          <path d="M5.87 3.52h1.26l-.18 4.54H6.05l-.18-4.54zm.63 5.36c-.41 0-.74.32-.74.72 0 .4.33.72.74.72.41 0 .74-.32.74-.72 0-.4-.33-.72-.74-.72z" fill="white"/>
        </svg>
        <span>${this._escapeHtml(message)}</span>
      `;
      errorEl.style.display = 'flex';
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    _clearError() {
      const errorEl = this.querySelector('[data-cart-error]');
      if (errorEl) {
        errorEl.style.display = 'none';
        errorEl.innerHTML = '';
      }
    };

    _escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    };

    async _handleNotifySubmit(e) {
      e.preventDefault();
      const email = this.$notifyEmail?.value.trim();
      if (!email || !this.$notifyEmail.checkValidity()) {
        this._showNotifyError('Please enter a valid email address.');
        return;
      }
      const variantId = this.$notifyForm.dataset.variantId;
      const companyId = this.$notifyForm.dataset.companyId;

      this.$notifyButton.setAttribute('loading', '');
      this.$notifyButton.disabled = true;

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'revision': '2024-10-15'
            },
            body: JSON.stringify({
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: { email }
                    }
                  },
                  channels: ['EMAIL']
                },
                relationships: {
                  variant: {
                    data: {
                      type: 'catalog-variant',
                      id: `$shopify:::$default:::${variantId}`
                    }
                  }
                }
              }
            })
          }
        );
        if (response.status === 202) {
          this.$notifyEmail.style.display = 'none';
          this.$notifyButton.style.display = 'none';
          this.$notifySuccess.style.display = '';
          this.$notifyError.style.display = 'none';

          // Record pooled product subscription for backend restock notification
          const poolType = this.$notifyForm.dataset.poolType;
          if (poolType) {
            fetch('https://script.google.com/macros/s/AKfycbxvLdXrC24ztTKkcZcGV_Mpx_001jglf99c3H18HBWX9KpyjoZ4f22He3pyXDT2zDB_jw/exec', {
              method: 'POST',
              body: JSON.stringify({
                action: 'register_bis_subscription',
                apiKey: 'rp_prod_902a9c1e0f42c682e4ea711b7fca8163d30345720917dd4b',
                email: email,
                variantId: variantId,
                variantTitle: this.$notifyForm.dataset.variantTitle,
                variantWeight: parseFloat(this.$notifyForm.dataset.variantWeight),
                productId: this.$notifyForm.dataset.productId,
                productTitle: this.$notifyForm.dataset.productTitle,
                productUrl: this.$notifyForm.dataset.productUrl,
                poolType: poolType
              })
            }).catch(() => {});
          }
        } else {
          this._showNotifyError('Something went wrong. Please try again.');
        }
      } catch {
        this._showNotifyError('Something went wrong. Please try again.');
      } finally {
        this.$notifyButton.removeAttribute('loading');
        this.$notifyButton.disabled = false;
      }
    };

    _showNotifyError(message) {
      if (this.$notifyError) {
        this.$notifyError.textContent = message;
        this.$notifyError.style.display = '';
      }
    };

    _resetNotifyForm() {
      if (!this.$notifyEmail) return;
      this.$notifyEmail.value = '';
      this.$notifyEmail.style.display = '';
      this.$notifyButton.style.display = '';
      this.$notifyButton.removeAttribute('loading');
      this.$notifyButton.disabled = false;
      this.$notifySuccess.style.display = 'none';
      this.$notifyError.style.display = 'none';
    };
  });
})();